var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"11","height":"11","fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","d":"M10.845 6.87H6.659v4.117H4.727V6.87H.541V5.053h4.186V.913h1.932v4.14h4.186z"}})])
}
var staticRenderFns = []

export default { render: render }